var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var TextArea = styled.textarea(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  width: 100%;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 12px 12px;\n  line-height: 1em;\n  font-size: 1.4rem;\n  outline: none;\n  color: ", ";\n\n  &:focus {\n    background-color: ", ";\n    border: 1px solid ", ";\n  }\n  &:read-only {\n    background-color: ", ";\n    border: 1px solid\n      ", ";\n    color: ", ";\n    &:focus {\n      background-color: ", ";\n    }\n  }\n"], ["\n  display: inline-block;\n  width: 100%;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 12px 12px;\n  line-height: 1em;\n  font-size: 1.4rem;\n  outline: none;\n  color: ", ";\n\n  &:focus {\n    background-color: ",
    ";\n    border: 1px solid ",
    ";\n  }\n  &:read-only {\n    background-color: ", ";\n    border: 1px solid\n      ", ";\n    color: ", ";\n    &:focus {\n      background-color: ",
    ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.name === "default"
        ? theme.gwThemed.inputs.main.focusBg
        : theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.name === "default"
        ? theme.gwThemed.inputs.main.borderColor
        : theme.gwThemed.inputs.main.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.disabled.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.disabled.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.disabled.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.disabled.focusBg;
});
var templateObject_1;
//# sourceMappingURL=TextArea.js.map